import { createContext, type Dispatch, type SetStateAction } from 'react'

type ChartCursorProviderState = {
  cursorTimestamp: number | null
  setCursorTimestamp: Dispatch<SetStateAction<number | null>>
}

export const ChartCursorProviderContext =
  createContext<ChartCursorProviderState>({
    cursorTimestamp: null,
    setCursorTimestamp: () => null,
  })
